module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/4@2x_2b4d70d689984dc6b17fae53733a7633.png";